module.exports = __webpack_public_path__ + "static/img/flatPeach.8552c41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/flatPeach.jpg
// module id = 24Q0
// module chunks = 1